// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  relocationFeatureEnabled: false,
  vouchersFeaturesEnabled: true,
  partnerGroupingsFeaturesEnabled: true,
  api_base_urls: {
    ms_defaults: ['ms.magicpallet.com', 'http://localhost'],
    ms_users: 'https://dev.users.ms.magicpallet.com/',
    ms_stocks: 'https://dev.stocks.ms.magicpallet.com/',
    ms_notif: 'https://dev.notif.ms.magicpallet.com/',
    ms_alerting: 'https://dev.alerting.ms.magicpallet.com/',
    ms_data: 'https://dev.data.ms.magicpallet.com/'
  },
  authorized_urls: [
    'http://localhost/*',
    'https://dev.users.ms.magicpallet.com/*',
    'https://dev.stocks.ms.magicpallet.com/*',
    'https://dev.notif.ms.magicpallet.com/*',
    'https://dev.alerting.ms.magicpallet.com/*',
    'https://dev.data.ms.magicpallet.com/*'
  ],
  supportedLanguages: [
    'fr',
    'en',
    'es'
  ],
  defaultLanguage: 'fr',
  auth0Config: {
    tenantUrl: 'https://beta.auth.magicpallet.com',
    clientId: '4FPHYV0SuWJmdS8wBrbPwCr8yRboUzM6',
    scope: 'offline_access openid',
    audience: 'https://beta.api.magicpallet.com/pms/'
  },
  googleAPIKey: 'AIzaSyA2W-l3VpdGfarPFe2iBihHcWQh5N4GEA4',
  cloudStorageHelpURL: 'https://storage.googleapis.com/storage-help-beta-magicpallet/',
  cloudStorageImageURL:
    'https://storage.googleapis.com/dev-storage-file-magicpallet/',
  baseUrl: 'http://localhost:4200',
  protectedAcces: true,
  delayExpirationTickets: {
    // Twenty two days.
    soon: 1900800000,
    // Height days.
    expired: 691200000
  },
  map: {
    bounds: {
      southWest: {
        lat: 36,
        lng: -24
      },
      northEast: {
        lat: 72,
        lng: 66
      },
      strict: true
    }
  },
  hubspot: {
    meetingFormId: "dave-rideau-ridhuile",
    // meetingFormId: "l-b/demande-inscription-app",
  },
  maintenance: {
    maintenanceConfigPath: "https://storage.googleapis.com/storage-file-magicpallet/pms-maintenance/maintenance.dev.json",
    maintenanceWatcherInMs: 60000
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
